// Team
export function team() {
    const team = document.querySelectorAll('.senior-team-member');
    const closeModal = document.querySelectorAll('.close');

    team.forEach((teamMember) => {
        const teamOverlay = teamMember.nextElementSibling;
        teamMember.addEventListener('click', () => {
            teamOverlay.classList.add('show-modal');
        });
    });

    closeModal.forEach((close) => {
        const teamOverlay = close.parentElement.parentElement.parentElement.parentElement;
        close.addEventListener('click', () => {
            teamOverlay.classList.remove('show-modal');
        });
    });
}
